import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import 'react-phone-number-input/style.css';
import './style.scss';
import { VERIFICATION_PLACEHOLDER } from 'components/Utils/ChangePasswordScreen';
import { useAppSelector } from 'careand-redux/store';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { api } from 'careand-redux/api/ApiThunks';
import { RegistrationBottomNavigation } from 'scenes/PatientRegistration/Navigation';
import ProgressMessage from 'components/Utils/ProgressMessage';
import DefaultPatientTextField from 'components/Utils/DefaultPatientTextField';
import { Stacks, navigationActions } from 'careand-redux/slices/ui/navigation';
import { useNavStack } from 'careand-redux/slices/ui/hooks';

const CODE_LENGTH = 6;

const PhoneConfirmation = (props) => {
  const dispatch = useAppDispatch();
  const nav = useNavStack(Stacks.Master);

  const registration = useAppSelector((state) => state.registration);
  const authentication = useAppSelector((state) => state.authentication);

  const { track, path } = props;

  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const [code, setCode] = useState('');

  useEffect(() => {
    if (!registration.phone) {
      props.goToStart();
    }
  }, [registration.phone]);

  useEffect(() => {
    track('registrationSMSCode');
  }, [track]);

  useEffect(() => {
    let { personalData = {}, credentials } = registration;
    let missingData = !personalData.first_name || !credentials.username;
    if (missingData) nav.push(path);
  }, [registration, path]);

  async function registerAccount(overrideCode) {
    if (overrideCode) {
      overrideCode = overrideCode.split(VERIFICATION_PLACEHOLDER).join('');
      if (overrideCode.length !== CODE_LENGTH) return;
    }
    let payload = {
      phone: registration.phone,
      verification_code: overrideCode || code,
      username: registration.credentials.username,
      password: registration.credentials.password,
      email: registration.credentials.email.trim(),
      preferred_name: registration.preferred_name,
      preferred_pronoun: registration.preferred_pronoun,
      track_id: registration.track_id,
      ...registration.personalData,
    };

    setLoading(true);

    let result;

    if (authentication?.user?.id) {
      result = await dispatch(
        api.Authentication.registerLinkedAccount({ patientRegisterPayload: payload }),
        {
          title: 'Account Registration',
          successText: 'Linked Account registered successfully!',
        },
      );
    } else {
      result = await dispatch(
        api.Authentication.registerPatient({ patientRegisterPayload: payload }),
        { errorTitle: 'Account Registration' },
      );
    }

    if (result) {
      dispatch(navigationActions.activeAccountChanged());
      props.onSuccess();
    }
    setLoading(false);
  }

  async function resendCode(event) {
    event.preventDefault();
    event.stopPropagation();
    setResending(true);
    await dispatch(api.Authentication.sendPhoneVerification({ phone: registration.phone, resend: true }));
    setResending(false);
  }

  return (
    <div className="confirmation step">
      <span className="top-text">Enter the 6 digit code we sent to {registration.phone}</span>
      <form
        className="phone-validation"
        onSubmit={(event) => {
          event.preventDefault();
          registerAccount();
        }}
      >
        <DefaultPatientTextField
          id="code"
          name="code"
          value={code}
          autoFocus
          onChange={(event) => setCode(event.target.value)}
          autoComplete="one-time-code"
          inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
        />

        <div className="resend">
          {resending ? (
            <ProgressMessage />
          ) : (
            <span className="resend-text" onClick={resendCode}>
              Resend Code
            </span>
          )}
        </div>

        <RegistrationBottomNavigation id="validate-phone-btn" loading={loading} />
      </form>
    </div>
  );
};

PhoneConfirmation.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  track: PropTypes.func.isRequired,
};

export default PhoneConfirmation;
